export default __webpack_public_path__ + "static/media/TEST-1.f3f65bb6.jpeg";